module.exports = __webpack_public_path__ + "static/media/arrow-up.70bc3c3b.png";